import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  TextField
} from '@material-ui/core';

import { addVendor } from 'redux/actions';

const AddVendorModal = (props) => {

  const [values, setValues] = useState({
    name: "",
    phone: "",
    trn: ""
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newVendor = {
      displayId: props.displayId,
      name: values.name,
      phone: values.phone,
      trn: values.trn
    };
    props.addVendor(newVendor, true, props.activeUserId);

    props.closeModal(false);
  };

  return (
    <Modal open={props.open} >
      <form
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Card>
          <CardHeader
            subheader="The information can be edited later"
            title="Vendor"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the name"
                  label="Name"
                  name="name"
                  onChange={handleChange}
                  required
                  value={values.name}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the Phone Number"
                  label="Phone Number"
                  name="phone"
                  onChange={handleChange}
                  required
                  value={values.phone}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the TRN"
                  label="TRN"
                  name="trn"
                  onChange={handleChange}
                  required
                  value={values.trn}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 2
            }}
          >
            <Button
              color="primary"
              variant="contained"
              type="submit"
            >
              Save Vendor
            </Button>
            <Button sx={{ mx: 1 }} onClick={props.closeModal.bind(this, false)}>
              Cancel
            </Button>
          </Box>
        </Card>
      </form>
    </Modal>
  )
};

export default connect (null, {addVendor}) (AddVendorModal);